module.exports = __webpack_public_path__ + "static/media/search.800f7d3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search.svg
// module id = 192
// module chunks = 1